import {myLinks} from "@/lib/routes/myLinks";
import NextLink from "next/link";
import {useMemo} from "react";
import {useLocale} from "next-intl";

export const Link = ({children, route, query = {}, href, dynamic,...props}) => {
    const locale = useLocale();

    const getUrl = useMemo(()=>{
        let url = '#'

        if (href){
            url = href
        }

        if (route){
            url = myLinks.getUlr(route, query)
        }

        if ( locale !== 'en' ) {
            url = '/' + locale + url;
        }

        return dynamic ? `${url}?dynamic=${Math.random()}` : url
    }, [])

    return (
        <>
            <NextLink
                href={getUrl}
                {...props}
            >
                {children}
            </NextLink>
        </>
    );
}